import { useEffect } from "react";

import TreeNode from "../TreeNode";

const countPagesIncludingChildren = (pages) => {
  let count = pages.length;
  pages.forEach((page) => {
    if (page.children && page.children.length > 0) {
      count += countPagesIncludingChildren(page.children);
    }
  });
  return count;
};

const getAllPages = (pages, result = []) => {
  pages.forEach((page) => {
    result.push({ id: page.id, title: page.title, url: page.url });
    if (page.children && page.children.length > 0) {
      getAllPages(page.children, result);
    }
  });
  return result;
};

const TreePages = ({ userData, setUserData, setSelectedPages }) => {
  const totalPageCount = countPagesIncludingChildren(userData.pages);

  const firstPageName = userData.pages[0]?.title;
  const isSelectedFirstPage = (userData.selectedPages || []).some(
    (page) => page.title === firstPageName
  );

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allPages = getAllPages(userData.pages);
      setUserData({ ...userData, selectedPages: allPages });
    } else {
      setUserData({ ...userData, selectedPages: [] });
    }
  };

  useEffect(() => {
    setSelectedPages(
      isSelectedFirstPage
        ? userData.selectedPages.length - 1
        : userData.selectedPages.length
    );
  }, [userData.selectedPages, setSelectedPages, isSelectedFirstPage]);

  return (
    <div className="app-ai-quote-tree">
      <div className="app-ai-quote-tree-header">
        <p>
          {isSelectedFirstPage
            ? userData.selectedPages.length - 1
            : userData.selectedPages.length}{" "}
          of {totalPageCount - 1} pages selected
        </p>
        <div className="app-ai-quote-tree-header-select-all">
          <input
            type="checkbox"
            id="selectAll"
            name="selectAll"
            checked={userData.selectedPages.length === totalPageCount}
            onChange={handleSelectAll}
          />
          <label htmlFor="selectAll">Select All</label>
        </div>
      </div>
      <div className="app-ai-quote-tree-body">
        {userData.pages.map((node) => (
          <TreeNode
            key={node.id}
            node={node}
            userData={userData}
            setUserData={setUserData}
            totalPageCount={0}
          />
        ))}
      </div>
    </div>
  );
};

export default TreePages;
